import { createStyles } from "@mantine/core";

export const useStyles = createStyles(theme => ({
    wrapper : {
        boxShadow : "none",
        "section" : {
            boxShadow : 'none',
            padding : 10,
            marginBottom : 20,
            width : 500,
            "button" : { fontFamily : 'Regular' , fontWeight : "bold" },
            'thead' : {
                fontFamily : 'Regular'
            },
            'tr' : {
                'td' : {
            "button" : { fontFamily : 'Regular' , fontWeight : "normal" },
                }
            }
        }
    },
    btn : {
        width : 100
    },
    modal : {
        display : 'flex',
        flexDirection : 'column',
        rowGap : 20,
        overflow: 'hidden !important',

    },
    confirm : {
        color : 'black',
        fontSize : 20,
        textAlign : 'center',
        fontFamily : `Regular , ${theme.fontFamily}`,
        
    },
    errorPayment:{
      fontFamily: `Regular`,
      fontSize: '16px !important',
      color: theme.colors.error[0],
      textAlign : 'center',
    },
    actions : {
        display : 'flex',
        columnGap : 20,
        alignItems : 'center',
        justifyContent : "center"
    },
    cancel : {
        fontFamily : `Bold , ${theme.fontFamily}`,
        fontSize : 15,
       color : theme.colors.secondary[0],
       textDecoration : "none",
       ":hover" : {
           cursor : "pointer"
       }
    },
    gridRowFull: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: 10
      },
      gridItem: {
        // padding: '10px',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        [theme.fn.smallerThan(850)]: {},
        [theme.fn.smallerThan(1400)]: {},
        [theme.fn.smallerThan(1050)]: {}
      },
      bankDetailWrapper: {
        // margin: 20,
        [theme.fn.smallerThan(850)]: {
          margin: 0
        },
        [theme.fn.smallerThan(1400)]: {},
        [theme.fn.smallerThan(1050)]: {}
      },
      bankDetail: {
        backgroundColor: theme.colors.background[5],
        position: 'relative',
        width: '100%',
        borderRadius: 16,
        border: `1px solid ${theme.colors.primary[0]}`,
        height: 50,
        display: 'flex',
        flexDirection: 'column',
        alignItems: ' flexFnd'
      },
      bankIcon: {
        height: 31,
        right: 140,
        top: 8,
        position: 'absolute',
        width: 31
      },
      radioButtonPayment:{
        height: 31,
        left: 23,
        position: 'absolute',
        top: 13,
        width: 31
      },
      div: {
        height: 48,
        right: -70,
        position: 'absolute',
        top: 0,
        width: 191
      },
      divWrapper: {
        height: 24,
        left: 0,
        position: 'absolute',
        top: 24,
        width: 191
      },
      textWrapper: {
        color: theme.colors.text[1],
        fontFamily: `Medium , ${theme.fontFamily}`,
        fontSize: 16,
        fontWeight: 500,
        left: 0,
        letterSpacing: '0.15px',
        opacity: 0.5,
        position: 'absolute',
        top: 0,
        minWidth: 200
      },
      textWrapper2: {
        color: theme.colors.secondary[0],
        fontFamily: `Medium , ${theme.fontFamily}`,
        fontSize: 16,
        fontWeight: 500,
        left: 2,
        letterSpacing: '0.15px',
        position: 'absolute',
        top: 0
      },
      statusBtns: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        [theme.fn.smallerThan(650)]: {
          display: 'none'
        }
      },
      accountStatus: {
        color: theme.colors.secondary[0],
        fontFamily: `Medium , ${theme.fontFamily}`,
        fontSize: 16,
        fontWeight: 500,
        right: 81,
        letterSpacing: '0.15px',
        lineHeight: 'normal',
        position: 'absolute',
        top: 15,
        cursor: 'pointer'
      },
      paymentMethod:{
        color : 'black',
        fontSize : 16,
        textAlign : 'left',
        fontFamily : `Medium , ${theme.fontFamily}`,
      }
}))